<template>
  <div>
    <Header :logged="logged" />

    <div id="cartorios">
      <b-container :class="'cartorios-container ' + (exibir_cartorios? 'inspect-cartorio':'list-cartorios')" cols="12" 	sm="6" 	md="12" 	lg="12">
        <b-row>
          <b-col v-if="exibir_cartorios" cols="12" 	sm="12" 	md="12" 	lg="12">

            <div id="wrapper-spinner" v-if="loading_cartorios">
              <BeatLoader color="var(--main-azul)" />
            </div>
            <div v-else class="cartorio-content-container">
              <b-button variant="outline-secondary float-right d-none d-sm-block" @click="fechar_cartorios()">Voltar<img src="~@/assets/imgs/icons/return-icon.svg" /></b-button>

              <img class="flag-header" :src="require('@/assets/imgs/bandeiras/flag-'+(uf_selecionada.Sigla).toLowerCase()+'.png')" :alt="uf_selecionada.Sigla">
              <h2 class="text-primary mb-4">{{ uf_selecionada.Nome }}</h2>

              <div>
                <b-card no-body class="card-cartorios-uf">
                  <!-- <b-tabs card>
                    <b-tab title="Participantes" active> -->
                      
                      <b-button variant="outline-secondary float-right d-sm-none" @click="fechar_cartorios()">Voltar<img src="~@/assets/imgs/icons/return-icon.svg" /></b-button>
                      <div v-if="alfabeto.length > 0" class="letras">
                        <div class="letra shadow-sm" :class="{ active: letra == l, disabled: !alfabeto.includes(l) }" v-for="l of letras" :key="l" @click="alfabeto.includes(l)?porLetra(l):''">{{ l }}</div>
                        <div class="letra todas shadow-sm" @click="letra = false">TODAS</div>
                      </div>
                      <div class="lista-cartorios-body">

                        <b-card-text class="lista-catorios-uf-card">
                          <div v-for="municipio of cartorios.participantes" :key="municipio.ibge">
                            <b-card-group v-if="letra === false || (municipio.letra == letra)" class="mb-3" deck>
                              <b-card class="lista-cartorios" :header="municipio.nome_municipio.toUpperCase()">
                              <ul class="list-group list-group-flush">
                                <li class="list-group-item" v-for="(cartorio, index) in municipio.cartorios" :key="index">
                                  <p>{{ cartorio.nome }}</p>
                                  <div class="lista-cartorios-texto-coluna"><small><b>Endereço: </b>{{ cartorio.endereco.toUpperCase() | enderco }}</small><small><b>Bairro:</b> {{ cartorio.bairro.toUpperCase() }} <strong>CEP:</strong> {{ cartorio.cep | CEP}}</small></div>
                                  <div class="lista-cartorios-texto-coluna"><small><b>Telefone: </b>{{ cartorio.telefone | fone }}</small><small><b>Data de atualização:</b> {{ cartorio.data_atualizacao | formatar_data }}</small></div>
                                  <!-- <div v-if="cartorio.whatsapp != null"><small><b>Whastapp:</b> {{ cartorio.whatsapp }}</small></div> -->
                                </li>
                              </ul>
                            </b-card>
                          </b-card-group>
                        </div>
                      </b-card-text>
                    </div>
                    <!-- </b-tab> -->
                    <!-- <b-tab title="Não participantes">

                      <div v-if="alfabeto_nao.length > 0" class="letras">
                        <div class="letra shadow-sm" :class="{ active: letra_nao == l }" v-for="l of alfabeto_nao" :key="l" @click="porLetra(l, true)">{{ l }}</div>
                        <div class="letra todas shadow-sm" @click="letra_nao = false">TODAS</div>
                      </div>

                      <b-card-text>
                        <div v-for="municipio of cartorios.nao_participantes" :key="municipio.ibge">
                          <b-card-group v-if="letra_nao === false || (municipio.letra == letra_nao)" class="mb-3" deck>
                            <b-card class="lista-cartorios" :header="municipio.nome_municipio">
                              <ul class="list-group list-group-flush">
                                <li class="list-group-item" v-for="(cartorio, index) in municipio.cartorios" :key="index">
                                  <p>{{ cartorio.nome }}</p>
                                  <div><small>{{ cartorio.endereco }}</small></div>
                                  <div><small><b>Data de atualização:</b> {{ cartorio.data_atualizacao | formatar_data }}</small></div>
                                </li>
                              </ul>
                            </b-card>
                          </b-card-group>
                        </div>
                      </b-card-text>
                    </b-tab> -->
                  <!-- </b-tabs> -->
                </b-card>
              </div>
            </div>

          </b-col>
          <b-col v-else  cols="12" 	sm="12" 	md="12" 	lg="12">
            <b-row align-h="center">
              <b-col cols="12">
                <h1>Cartórios Participantes</h1>
              </b-col>
              <!-- <b-col cols="4">
                <b-button variant="outline-secondary float-right" @click="$router.push({ name: 'home' })"> Voltar</b-button>
              </b-col> -->
            </b-row>
            <p>Clique no estado abaixo para saber os dados dos 3.760 cartórios de protesto do Brasil</p>
            <b-card >
              <b-row>
                <b-col class="mx-auto">
              <div v-for="UF of estados" :key="UF.ID" class="flag mt-2" @click="get_cartorios(UF)">
                <b-card>
                  <figure>
                    <div class="mx-auto">
                    <img  :src="require('@/assets/imgs/bandeiras/flag-'+(UF.Sigla).toLowerCase()+'.png')" :alt="UF.Sigla">
                    <figcaption>{{ UF.Nome }}</figcaption>
                    </div>
                  </figure>
                </b-card>
              </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
    
    <footersite class="d-none d-xl-block" />
    <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import Header from '../components/Header'
import Estados from '../services/estados'
import API from '../services/api'
import footersite from "../components/footersite";
import footersitemobile from "../components/footersite/index_mobile";

  

export default {
  components: {
    Header,
    BeatLoader,
    footersite,
    footersitemobile,
  },
  methods: {
    async get_cartorios(UF) {
      this.loading_cartorios = true
      this.exibir_cartorios = true
      const res = await API.get(`cartorios/${UF.Sigla}`)
      this.uf_selecionada = UF

      this.alfabeto = this.get_alfabeto(res.data.participantes)
      this.alfabeto_nao = this.get_alfabeto(res.data.nao_participantes)

      this.cartorios = res.data

      this.letra_nao = false
      this.letra = false

      setTimeout(() => this.loading_cartorios = false, 250)
    },
    get_alfabeto(cartorios) {
      // monta alfabeto
      let alfabeto = []
      for(let item of cartorios) {
        let letra = item.nome_municipio.substr(0, 1).normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if(!alfabeto.includes(letra)) alfabeto.push(letra)
        item.letra = letra
      }
      return alfabeto
    },
    fechar_cartorios() {
      this.uf_selecionada = false
      this.cartorios = {}
      this.exibir_cartorios = false
    },
    porLetra(letra, nao) {
      if(nao) {
        this.letra_nao = letra
      } else {
        this.letra = letra
      }
    }
  },
  data() {
    return {
      alfabeto: [],
      letras: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      letra: false,
      alfabeto_nao: [],
      letra_nao: false,
      estados: {},
      uf_selecionada: {},
      cartorios: {},
      exibir_cartorios: false,
      logged: false,
      loading_cartorios: false
    }
  },
  filters: {
    fone: function (value){
      if (value != undefined) {
        var d = ''
        if(value.length > 10){
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{5})(\d)/, "$1-$2")
          return d
        }else{
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{4})(\d)/, "$1-$2")
          return d
        }
      }
    },
    CEP: function (value){
      var d = value
      d = d.replace(/\D/g, "")
      d = d.replace(/^(\d{5})(\d)/, "$1-$2")
      return d
    },
    endereco: function (value) {
      if ((value == undefined) || (value == '')) {
        return 'Rua única'
      }
    }
  },
  mounted() {
    this.estados = Estados
    //this.get_cartorios(this.estados[1])

    this.$root.isLogged().then(() => {
      this.logged = true
    }).catch(() => {
      this.logged = false
    })
  },
}
</script>

<style scoped>
h1{text-align: center;font: normal normal 200 42px/70px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--primary-color);margin-bottom: 30px;}
p{text-align: center;font: normal normal 200 16px/20px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--primary-color);margin-bottom: 20px;}
figcaption{font: normal normal 200 16px/20px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--secondary-color);}
#cartorios .card {border: none;border-radius: 40px;}
#cartorios .inspect-cartorio .card.card-cartorios-uf {border-radius: 0px;border-top: 3px solid var(--secondary-color);padding-top: 40px;padding-right: 18px;}
#cartorios .flag .card{box-shadow: 0px 2px 10px 0px rgb(110 130 208 / 30%);}
.letras {display: flex;justify-content: center;height: fit-content;margin-bottom: 40px;width: 280px;background: none;flex-wrap: wrap;align-self: center;}
  .letras .letra{
    border:none;
    min-width: unset;
    box-shadow: none !important;
    outline: none;
    padding: 0;
    font: normal normal 300 16px/20px 'Kanit', sans-serif;
    width: 40px;
    height: 40px;
    text-align: center;
    display: flex !important;
    align-items: center;
    justify-content: center;
    color: var(--secondary-color);
    margin:0 !important;}
    .letras .letra.todas{width: fit-content;padding: 0; width: 80px;}
    .letras .letra:active, .letras .letra:hover, .letras .letra.active {box-shadow: none !important;outline: none;border:none;background: var(--secondary-color);color: white !important;border-radius: 100% !important;}
    .letras .letra.todas:active, .letras .letra.todas:hover, .letras .letra.todas.active {border-radius:10px !important;}
    .letras .letra.disabled, .letras .letra.disabled:hover{color: #D9D9D9 !important; background:none;cursor: not-allowed;}
    /* .letras .letra:after{content:'';display:flex;width: 100%;height: 5px;background-color: transparent;} */
        /* .letras .letra.active:after, .letras .letra:hover:after, .letras .letra:active:after{background-color: #597EB5;} */
  #cartorios .inspect-cartorio .card.card-cartorios-uf .lista-cartorios-body{border: 1px solid #F1F1F1;padding: 27px 29px 27px 32px;height: fit-content; max-height: 90vh;overflow: hidden;}
    #cartorios  .inspect-cartorio .lista-cartorios-body .lista-catorios-uf-card {padding: 0 15px 2.75rem 0;overflow: overlay;max-height: 90vh;}
      #cartorios  .inspect-cartorio .lista-cartorios-body .lista-catorios-uf-card::-webkit-scrollbar {width: 3px;}
      #cartorios  .inspect-cartorio .lista-cartorios-body .lista-catorios-uf-card::-webkit-scrollbar-track {background: #7070703B;border-radius: 20px;}
      #cartorios  .inspect-cartorio .lista-cartorios-body .lista-catorios-uf-card::-webkit-scrollbar-thumb {background: #597EB5;border-radius: 20px;}
      #cartorios .inspect-cartorio .lista-cartorios-body .lista-catorios-uf-card::-webkit-scrollbar-thumb:hover {background: #597EB5;}
  #cartorios .lista-cartorios .card-header{background: var(--navbar-gray-color) 0% 0% no-repeat padding-box;border: 1px solid var(--navbar-gray-color);border-radius: 5px 5px 0px 0px;font: normal normal 300 16px/20px 'Kanit' !important;letter-spacing: -1%;text-align:start;color: #FFFFFF;}
  #cartorios .lista-cartorios .card-body{height: 152px;background: #F1F1F1 0% 0% no-repeat padding-box;border-radius: 0px 0px 5px 5px;padding: 20px 17px 32px 21px;}
  #cartorios .lista-cartorios .card-body .list-group {margin: 0;}
  #cartorios .lista-cartorios .card-body .list-group .list-group-item{background-color: unset;margin: 0;padding: 0;display: flex;flex-wrap: wrap;}
  #cartorios .lista-cartorios .card-body .list-group .list-group-item p{width:100%;text-align: left;font: normal normal 200 16px/20px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--secondary-color);margin-bottom: 28px;}
  #cartorios .lista-cartorios .card-body .list-group .list-group-item .lista-cartorios-texto-coluna {display: flex;flex-flow: column;width: 70%;align-items: start;}
    #cartorios .lista-cartorios .card-body .list-group .list-group-item .lista-cartorios-texto-coluna:last-child {align-items: flex-end;width: 30%;}
      #cartorios .lista-cartorios .card-body .list-group .list-group-item .lista-cartorios-texto-coluna small{text-align: left;font: normal normal 200 16px/32px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--secondary-color);}
      
#cartorios .cartorios-container h2.text-primary{
  text-align: start;
  height: 62px;
  font: normal normal 200 50px/77px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: var(--secondary-color) !important;
  display: flex;
  align-items: center;
}
#cartorios button.btn-outline-secondary {height:62px;display:flex;align-items:center;justify-content:center;border:none;padding: 0;font: normal normal 200 20px/20px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--secondary-color);}
  #cartorios .btn-outline-secondary img{width: 21px;height: 21px;margin-left: 6px;}
    #cartorios button.btn-outline-secondary:active, #cartorios button.btn-outline-secondary:hover {background-color: unset;outline: none;border: none;-webkit-box-shadow: none;box-shadow: none;}


@media (min-width: 1200px){

  #cartorios .inspect-cartorio.container,
  #cartorios .inspect-cartorio.container-sm,
  #cartorios .inspect-cartorio.container-md,
  #cartorios .inspect-cartorio.container-lg,
  #cartorios .inspect-cartorio.container-xl{max-width: 980px;padding: 0;}
    #cartorios .cartorios-container.inspect-cartorio .row{margin: 0;margin-left: 16px;}
      #cartorios .cartorios-container.inspect-cartorio .row .col-lg-12{padding: 0;}

}


@media (min-width: 360px) {
   .container {
   width: 100%;
   text-align: center
 }
 .res {
  cursor: pointer;
  display: inline-block;
  width: 50%;
  margin: 0px;
  padding: 10px;
  text-align: center;
}
}
#wrapper-spinner {
  position: fixed;
  width: 96%;
  left: 0px;
  bottom: 0px;
  padding-top: 30px;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}

#cartorios {
  overflow-y: auto;
  /* position: fixed; */
  width: 100%;
  /* left: 0px; */
  /* bottom: 0px; */
  padding-top: 34px;
  margin-top:40px;
  /* top: 120px; */
  /* height: calc(100% - 80px); */
  /* max-height: calc(100vh - 186px); */
  /* background-color: var(--main-bg-cinza); */
  
}
.cartorios-container {
  margin-bottom: 100px;
}
.card-header {
  font-weight: bold;
}

.flag-header {
  float: left;
  height: auto;
  width: 88px;
  margin-right: 44px;
  box-shadow: 0px 2px 10px 0px rgba(110,130,208,0.2);
}
@media (min-width:  768px) {
.flag {
  cursor: pointer;
  display: inline-block;
  width: 50%;
  margin: 0px;
  padding: 10px;
  text-align: center;
}
}
@media (min-width:  1200px) {
.flag {
  cursor: pointer;
  display: inline-block;
  width: 20%;
  margin: 0px;
  padding: 10px;
  text-align: center;
}
}
.flag .card:hover {
  box-shadow: 0px 2px 10px 0px rgba(110,130,208,0.3);
}
figure {
  margin: 8px 0px 0px 0px;
}
.flag img {
  box-shadow: 0px 2px 10px 0px rgba(110,130,208,0.3);
}
figcaption {
  margin: 21px 0px 0px 0px;
}

.tab-pane {
  overflow-y: auto;
  height: 700px;
}

.lista-cartorios .card-body {
  padding: 10px;
}

.letra {
  cursor: pointer;
  display: inline-block;
  min-width: 35px;
  padding: 5px 0px 6px 0px;
  margin-right: 10px;
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 5px;
  text-align: center;
}

.letra.todas {
  padding: 5px 10px 6px 10px;
}
.letra:hover, .letra.active {
  color: var(--main-azul);
  border: 1px solid rgba(0,0,0,0.2);
}
.lista-cartorios-texto-coluna strong{font-weight: normal;}
@media (max-width:1199px){
  #cartorios{
    position:unset;
    margin-top: 69px;
    height: fit-content;
    max-height: unset;
    width: calc(100% - 34px);
    margin: 0 auto;
    margin-top: 68px;
  }
  #cartorios .inspect-cartorio .card.card-cartorios-uf{
    padding:0;
    padding-top:40px;
  }
  /* #cartorios .inspect-cartorio .card.card-cartorios-uf .lista-cartorios-body{padding: 23px 9px 27px 19px;} */
  #cartorios .inspect-cartorio .card.card-cartorios-uf .lista-cartorios-body{padding: 0;}
  #cartorios .lista-cartorios .card-header{text-align: center;}
  #cartorios .lista-cartorios .card-body{
    /* height: 252px; */
    height: fit-content;
    padding: 26px 15px 35px 15px;}
  .lista-cartorios-texto-coluna strong{font-weight: bold;}
  .cartorio-content-container{display: flex;flex-flow: column;justify-content: center;align-items: center;}
  .flag-header{margin:0}
  #cartorios button.btn-outline-secondary{align-self: flex-end;}
  .letras{height: 38px;background: #F1F1F1;align-items: center;width: calc(100vw - 34px);flex-wrap: wrap;height: fit-content;}
  #cartorios .lista-cartorios .card-body .list-group .list-group-item .lista-cartorios-texto-coluna{width: 100%;}
  #cartorios .lista-cartorios .card-body .list-group .list-group-item .lista-cartorios-texto-coluna:last-child{width: 100%;align-items: flex-start;}
}
</style>
